(function(){
    'use strict'

    angular.module('app.usuarios')
    .factory('UsuariosService', UsuariosService);

    UsuariosService.$inject = ['$http', '$q', 'apiSettings', 'UserInfoService'];

    function UsuariosService($http, $q, apiSettings, UserInfoService) {

        var api = {
            getAll: getAll,
            getById: getById,
            save: save,
            savePublic: savePublic,
            recuperarPassword: recuperarPassword,
            update: update,
            remove: remove,
            changePassword: changePassword
        };

        return api;

        function getStringParams(params){
            let stringParams = '';
            if(params != undefined && params != null)
            {
                params.forEach(element => {
                    stringParams += `/${element}`
                });
            }
            return stringParams;
        };

        function getAll(params){

            var url = apiSettings.apiBaseUrl + 'api/usuarios' + getStringParams(params);
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

        function getById(usuarioId){

            var url = apiSettings.apiBaseUrl + 'api/usuarios/' + usuarioId;
            
            return $http.get(url)
            .then(getByIdSuccess, getByIdError);

            function getByIdSuccess(response){
                return response.data;
            };

            function getByIdError(error) {
                return $q.reject(error);
            }
        };

        function save(usuario){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/usuarios',  
                method: 'POST',  
                data: usuario
            });  
            return response;
        };

        function savePublic(usuario){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/usuarios-public',  
                method: 'POST',  
                data: usuario
            });  
            return response;
        };

        function recuperarPassword(usuario){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/usuarios-public/recuperar-password',  
                method: 'POST',  
                data: usuario
            });  
            return response;
        };

        function update(usuario){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/usuarios',  
                method: 'PUT',  
                data: usuario
            });  
            return response;
        };

        function remove(usuario){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/usuarios',  
                method: 'DELETE', 
                headers: { 
                    'Content-Type': 'application/json' },
                data: usuario
            });  
            return response;
        };

        function changePassword(usuario){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/usuarios/change-password',  
                method: 'PUT',  
                data: usuario
            });  
            return response;
        };

    };

})();